import React, { useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Alert } from 'react-bootstrap';
import axios from 'axios';

function AgendaModif({ show, quit, eventmodif,success,userData }) {
    const [isLoading, setIsLoading] = useState(false);
    const [modif,setModif] = useState(false);
    const [action,setAction] = useState(null);
    const [date_debut, setDate_debut] = useState(eventmodif[1]); 
    const [date_fin, setDate_fin] = useState(eventmodif[4]);
    const [heure_debut, setHeure_debut] = useState(eventmodif[2]);
    const [heure_fin, setHeure_fin] = useState(eventmodif[3]);
    const [localisation, setLocalisation] = useState(eventmodif[0]._def.title.split(',')[1]);
    const [couleur, setCouleur] = useState(eventmodif[0]._def.ui.backgroundColor); 
    const [sujet, setSujet] = useState(eventmodif[0]._def.title.split(',')[0]);
    const [error,setError] = useState(null)
    const apiUrl = process.env.REACT_APP_API_URL;


    const handleModif = async (e) => {
        const fetchData = async () => {
          try {
            setModif(false)
            setIsLoading(true);
           if (!date_debut || !date_fin || !heure_debut || !heure_fin || !localisation || !couleur || !sujet) {
              setError("Veuillez remplir tous les champs du formulaire.");
              setIsLoading(false);
              return;
            }
            await axios.patch(
              `${apiUrl}/agenda/modification`,
              {
                idEquipe : userData.user.donnée.results[0].id_equipe,
                id_evenement : eventmodif[5],
                date_debut:date_debut,
                date_fin:date_fin,
                heure_debut:heure_debut,
                heure_fin:heure_fin,
                localisation:localisation,
                couleur:couleur,
                sujet:sujet
              },
              {
                withCredentials: true 
              }
            );
            setError(null);
            setIsLoading(false);
            success();
            quit();
            window.location.reload();
    
    
    
          } catch (error) {
            if (error.response) {
                
              setError(error.response.data.message);
            } else {
           
              setError(true)
            }
            setIsLoading(false);
          }
        };
    
        fetchData(); 
      };

      const handleSupp = async (e) => {
        const fetchData = async () => {
          try {
            setModif(false)
            setIsLoading(true);

            await axios.delete(
              `${apiUrl}/agenda/supprimer`,
              {
                  withCredentials: true, 
                  data: {
                      idEquipe: userData.user.donnée.results[0].id_equipe,
                      id_evenement: eventmodif[5]
                  }
              }
          );
            setError(null);
            setIsLoading(false);
            success();
            quit();
            window.location.reload();
    
    
    
          } catch (error) {
            if (error.response) {
                
              setError(error.response.data.message);
            } else {
           
              setError(true)
            }
            setIsLoading(false);
          }
        };
    
        fetchData(); 
      };



      if (isLoading) {
        return (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
        
        );  
      } 
    if(modif){
        return(
            <Modal show={modif} onHide={() => setModif(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{action.charAt(0).toUpperCase() + action.slice(1)} l'événement </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>Êtes-vous sûr de {action} l'évévement ?</>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setModif(false)}>
                Annuler
              </Button>
              {action === "supprimer" && (
                  <Button variant="primary" onClick={(e) => { handleSupp(e) }}  style={{ backgroundColor: "#00E676", borderColor: '#00E676' }}>
                      Supprimer l'événement
                  </Button>
              )}
              {action === "modifier" && (
                  <Button variant="primary" onClick={(e) => { handleModif(e) }} style={{ backgroundColor: "#00E676", borderColor: '#00E676' }}>
                      Modifier l'événement
                  </Button>
              )}
            </Modal.Footer>
          </Modal>
        )
    }

  return (
    <Modal show={show} onHide={quit}>
    <Modal.Header closeButton>
      <Modal.Title>Modifier ou supprimer un événement</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <div className='card'>
        <div className='card-body'>
            <div className='ajout'>
                {error && (
                    <Alert key="danger" variant="danger"  style={{fontSize:"15px", margin:"auto", width : "90%"}}>
                        Erreur ! {error}
                    </Alert>
                ) }
                <form className="Invite_Joueur" > 
                <div>
                    <label htmlFor="nom" className="label-1" >
                    <br />Date de début<br />
                    <input
                        name="date_debut"
                        type="date"
                        id="date_debut"
                        required
                        value={date_debut}  onChange={(e) => {setDate_debut(e.target.value)}}
                    />
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="new_adress" className="label-1" >
                        <br />Date de fin<br />
                            <input
                            name="date_fin"
                            type="date"
                            id="date_fin"
                            required
                            value={date_fin}  onChange={(e) => {setDate_fin(e.target.value)}}
                            />
                        </label>
                </div>
                <div>
                    <label htmlFor="nom" className="label-1" >
                    <br />Heure de début<br />
                    <input
                        type="time"
                        id="heure_debut"
                        name="heure_debut"
                        required
                        value={heure_debut}  onChange={(e) => {setHeure_debut(e.target.value)}}
                        />
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="nom" className="label-1" >
                    <br />Heure de fin<br />
                    <input
                        type="time"
                        id="heure_fin"
                        name="heure_fin"
                        required
                        value={heure_fin}  onChange={(e) => {setHeure_fin(e.target.value)}}
                        />
                    </label>
                </div>
                <div>
                <label htmlFor="nom" className="label-1" >
                    <br />Localisation de l'événement<br />
                    <input
                        type="localisation"
                        id="text"
                        name="localisation"
                        required
                        value={localisation}  onChange={(e) => {setLocalisation(e.target.value)}}
                        />
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="nom" className="label-1" required>
                    <br />Couleur<br />
                    <label className={`color-option vert ${couleur === 'color-1' ? 'selected' : ''}`}  onChange={(e) => {setCouleur("color-1")}}>
                        <input type="radio" name="couleur" value="vert" style={{display:"none"}}  />
                    </label>
                    &nbsp;
                    <label className={`color-option jaune ${couleur === 'color-2' ? 'selected' : ''}`} onChange={(e) => {setCouleur("color-2")}}>
                        <input type="radio" name="couleur" value="jaune" style={{display:"none"}} />
                    </label>
                    &nbsp;
                    <label className={`color-option rouge ${couleur === 'color-3' ? 'selected' : ''}`} onChange={(e) => {setCouleur("color-3")}}>
                        <input type="radio" name="couleur" value="rouge" style={{display:"none"}} />
                    </label>
                    &nbsp;
                    <label className={`color-option bleu ${couleur === 'color-4' ? 'selected' : ''}`}  onClick={() => setCouleur("color-4")}>
                      <input type="radio" name="couleur" value="bleu" style={{display:"none"}} />
                    </label>
                    </label>
                </div>
                <div>
                    <label htmlFor="nom" className="label-1" >
                    <br />Sujet de l'événement<br />
                        <textarea placeholder=" Entraînement musculaire..." value={sujet}  onChange={(e) => {setSujet(e.target.value)}}  rows="2" cols="40" ></textarea>
                    </label>
                </div>
                <br></br>
                </form>
            </div>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={quit}>
        Annuler
      </Button>
      <Button variant="danger" onClick={(e) => { setModif(true);setAction("supprimer") }}  >
        Supprimer
      </Button>
      <Button variant="primary" onClick={(e) => { setModif(true);setAction("modifier")}} style={{ backgroundColor: "#00E676", borderColor: '#00E676' }}>
        Modifier
      </Button>
    </Modal.Footer>
  </Modal>


  );
}

export default AgendaModif;
